<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-sm-10">
      <h2 v-if="crumbs.length>0" class='margin'>{{crumbs[crumbs.length-1].text }}</h2>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: crumb.to }" v-for="(crumb,index) in crumbs" :key="index">{{crumb.isData?crumb.text: crumb.text }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
import broadcast from "../../lib/broadcast";
export default {
  name: "breadcrumbController",
  data() {
    return {
      crumbs: []
    };
  },
  computed: {
  },
  watch:{
    $route (to, from){
        this.crumbs = this.$route.meta.breadcrumbs
       
    }
  }, 
  methods: {
    setBreadcrumb: function(data) {
        this.crumbs = this.$route.meta.breadcrumbs
    }
  },
  created: function() {
  },
  mounted() {
    let that = this;
    this.setBreadcrumb();
  }
};
</script>
